<template>
  <PrmButtonGroup class="qmulus-button-group">
    <slot />
  </PrmButtonGroup>
</template>

<script setup lang="ts">
import PrmButtonGroup from '@NitrexGroup/primevue/buttongroup';
</script>

<style scoped lang="scss">
.qmulus-button-group {
  &.p-button-group {
    :deep() {
      .p-button {
        white-space: nowrap;
      }

      .p-button:not(:first-child, :last-child),
      .p-togglebutton:not(:first-child, :last-child) .p-button {
        border-radius: 0;
        border-right: 0;
      }

      .p-button:first-child:not(:last-child),
      .p-togglebutton:first-child:not(:last-child) .p-button {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: 0;
      }

      .p-togglebutton:last-child:not(:first-child) .p-button {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  :deep(.p-togglebutton.p-highlight .p-button) {
    background-color: var(--toggle-button-secondary-active-bg);
    border-color: var(--toggle-button-secondary-active-border-color);
  }

  :deep(.p-togglebutton:not(.p-disabled):has(.p-togglebutton-input:hover).p-highlight .p-button) {
    background-color: var(--toggle-button-secondary-active-hover-bg);
    border-color: var(--toggle-button-secondary-active-border-hover-color);
  }
}
</style>
